var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBookmarkDeleteFilled2Color = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  className: "icon icon-bookmark-delete-filled-2color",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m26,4v25c0,.55-.45,1-1,1-.15,0-.28-.03-.41-.09l-4.3-1.91-4.29-1.91-4.29,1.91-4.3,1.91c-.13.06-.26.09-.41.09-.55,0-1-.45-1-1V4c0-1.1.9-2,2-2h16c1.1,0,2,.9,2,2Z",
  className: "background"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m24,2H8c-1.1,0-2,.9-2,2v25c0,.55.45,1,1,1,.15,0,.28-.03.41-.09l4.3-1.91,4.29-1.91,4.29,1.91,4.3,1.91c.13.06.26.09.41.09.55,0,1-.45,1-1V4c0-1.1-.9-2-2-2Zm-2.29,16.29c.39.39.39,1.02,0,1.41-.2.2-.45.29-.71.29s-.51-.1-.71-.29l-4.29-4.29-4.29,4.29c-.2.2-.45.29-.71.29s-.51-.1-.71-.29c-.39-.39-.39-1.02,0-1.41l4.29-4.29-4.29-4.29c-.39-.39-.39-1.02,0-1.41s1.02-.39,1.41,0l4.29,4.29,4.29-4.29c.39-.39,1.02-.39,1.41,0s.39,1.02,0,1.41l-4.29,4.29,4.29,4.29Z",
  className: "primary"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBookmarkDeleteFilled2Color);
export default ForwardRef;